module.exports = __webpack_public_path__ + "static/media/amenities-main-sc.24a14d37.png";